// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MultiSelectDropdown.css */

.msd-field {
  --msd-ink: #12131c;
  --msd-ink-soft: #565a72;
  --msd-ink-faint: #8b8fa3;
  --msd-paper: #f7f8fc;
  --msd-surface: #ffffff;
  --msd-line: #e2e4f0;
  --msd-line-strong: #cfd2e6;
  --msd-indigo: #4a4fe0;
  --msd-indigo-soft: #eef0ff;
  --msd-indigo-line: #c7c9fb;
  --msd-radius: 10px;
  --msd-shadow: 0 8px 24px -10px rgba(18, 19, 28, 0.18), 0 2px 6px rgba(18, 19, 28, 0.06);

  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-family: "Inter", system-ui, sans-serif;
  width: 100%;
  max-width: 420px;
}

.msd-label {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--msd-ink-soft);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Control (the box holding chips + input) */
.msd-control {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  min-height: 42px;
  padding: 6px 10px;
  background: var(--msd-surface);
  border: 1px solid var(--msd-line-strong);
  border-radius: var(--msd-radius);
  cursor: text;
  transition: border-color 0.14s ease, box-shadow 0.14s ease;
}

.msd-control:hover {
  border-color: var(--msd-ink-faint);
}

.msd-control-open {
  border-color: var(--msd-indigo);
  box-shadow: 0 0 0 3px var(--msd-indigo-soft);
}

.msd-disabled .msd-control {
  background: var(--msd-paper);
  cursor: not-allowed;
  opacity: 0.7;
}

.msd-chips {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 6px;
  flex: 1 1;
  min-width: 0;
  max-height: 64px; 
  overflow: auto;
  padding-right: 2px;
}

.msd-chips::-webkit-scrollbar {
  width: 5px;
}
.msd-chips::-webkit-scrollbar-thumb {
  background: var(--msd-line-strong);
  border-radius: 999px;
}

.msd-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--msd-indigo-soft);
  color: #3936a8;
  border: 1px solid var(--msd-indigo-line);
  border-radius: 999px;
  padding: 4px 6px 4px 12px;
  font-size: 12.5px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  animation: msd-chip-in 0.14s ease;
}

@keyframes msd-chip-in {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.msd-chip-remove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #3936a8;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  transition: background 0.12s ease, transform 0.12s ease;
}

.msd-chip-remove svg {
  display: block;
}

.msd-chip-remove:hover {
  background: rgba(74, 79, 224, 0.18);
  transform: scale(1.08);
}

.msd-chip-remove:disabled {
  cursor: not-allowed;
}

.msd-input {
  flex: 1 1;
  min-width: 80px;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13.5px;
  font-family: "Inter", system-ui, sans-serif;
  color: var(--msd-ink);
  padding: 4px 2px;
}

.msd-input::placeholder {
  color: var(--msd-ink-faint);
}

.msd-chevron {
  flex-shrink: 0;
  align-self: center;
  color: var(--msd-ink-faint);
  transition: transform 0.15s ease, color 0.15s ease;
  margin-right: 4px;
}

.msd-chevron-open {
  transform: rotate(180deg);
  color: var(--msd-indigo);
}

/* Dropdown panel */
.msd-panel {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background: var(--msd-surface);
  border: 1px solid var(--msd-line);
  border-radius: var(--msd-radius);
  box-shadow: var(--msd-shadow);
  overflow-y: auto;
  z-index: 30;
  animation: msd-panel-in 0.12s ease;
}

@keyframes msd-panel-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.msd-search-row {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--msd-line);
  color: var(--msd-ink-faint);
}

.msd-search-icon {
  flex-shrink: 0;
}

.msd-search-hint {
  font-size: 11.5px;
  font-weight: 500;
}

.msd-options {
  list-style: none;
  margin: 0;
  padding: 6px;
}

.msd-option {
  padding: 9px 12px;
  font-size: 13.5px;
  color: var(--msd-ink);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.1s ease, color 0.1s ease;
}

.msd-option:hover {
  background: var(--msd-indigo-soft);
  color: #3936a8;
}

.msd-empty {
  padding: 16px 12px;
  font-size: 13px;
  color: var(--msd-ink-faint);
  text-align: center;
}

/* Scrollbar polish for the options panel */
.msd-panel::-webkit-scrollbar {
  width: 6px;
}
.msd-panel::-webkit-scrollbar-thumb {
  background: var(--msd-line-strong);
  border-radius: 999px;
}`, "",{"version":3,"sources":["webpack://./src/Component/MultiSelectDropdown/MultiSelectDropdown.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,0BAA0B;EAC1B,0BAA0B;EAC1B,kBAAkB;EAClB,uFAAuF;;EAEvF,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2CAA2C;EAC3C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;EAChC,YAAY;EACZ,0DAA0D;AAC5D;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,cAAc;EACd,wCAAwC;EACxC,oBAAoB;EACpB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;EACV,uDAAuD;AACzD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,2CAA2C;EAC3C,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,2BAA2B;EAC3B,kDAAkD;EAClD,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,8BAA8B;EAC9B,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,2CAA2C;AAC3C;EACE,UAAU;AACZ;AACA;EACE,kCAAkC;EAClC,oBAAoB;AACtB","sourcesContent":["/* MultiSelectDropdown.css */\n\n.msd-field {\n  --msd-ink: #12131c;\n  --msd-ink-soft: #565a72;\n  --msd-ink-faint: #8b8fa3;\n  --msd-paper: #f7f8fc;\n  --msd-surface: #ffffff;\n  --msd-line: #e2e4f0;\n  --msd-line-strong: #cfd2e6;\n  --msd-indigo: #4a4fe0;\n  --msd-indigo-soft: #eef0ff;\n  --msd-indigo-line: #c7c9fb;\n  --msd-radius: 10px;\n  --msd-shadow: 0 8px 24px -10px rgba(18, 19, 28, 0.18), 0 2px 6px rgba(18, 19, 28, 0.06);\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  font-family: \"Inter\", system-ui, sans-serif;\n  width: 100%;\n  max-width: 420px;\n}\n\n.msd-label {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--msd-ink-soft);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* Control (the box holding chips + input) */\n.msd-control {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  min-height: 42px;\n  padding: 6px 10px;\n  background: var(--msd-surface);\n  border: 1px solid var(--msd-line-strong);\n  border-radius: var(--msd-radius);\n  cursor: text;\n  transition: border-color 0.14s ease, box-shadow 0.14s ease;\n}\n\n.msd-control:hover {\n  border-color: var(--msd-ink-faint);\n}\n\n.msd-control-open {\n  border-color: var(--msd-indigo);\n  box-shadow: 0 0 0 3px var(--msd-indigo-soft);\n}\n\n.msd-disabled .msd-control {\n  background: var(--msd-paper);\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.msd-chips {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n  max-height: 64px; \n  overflow: auto;\n  padding-right: 2px;\n}\n\n.msd-chips::-webkit-scrollbar {\n  width: 5px;\n}\n.msd-chips::-webkit-scrollbar-thumb {\n  background: var(--msd-line-strong);\n  border-radius: 999px;\n}\n\n.msd-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--msd-indigo-soft);\n  color: #3936a8;\n  border: 1px solid var(--msd-indigo-line);\n  border-radius: 999px;\n  padding: 4px 6px 4px 12px;\n  font-size: 12.5px;\n  font-weight: 600;\n  line-height: 1.4;\n  white-space: nowrap;\n  animation: msd-chip-in 0.14s ease;\n}\n\n@keyframes msd-chip-in {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.msd-chip-remove {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border: none;\n  border-radius: 50%;\n  background: transparent;\n  color: #3936a8;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0;\n  transition: background 0.12s ease, transform 0.12s ease;\n}\n\n.msd-chip-remove svg {\n  display: block;\n}\n\n.msd-chip-remove:hover {\n  background: rgba(74, 79, 224, 0.18);\n  transform: scale(1.08);\n}\n\n.msd-chip-remove:disabled {\n  cursor: not-allowed;\n}\n\n.msd-input {\n  flex: 1;\n  min-width: 80px;\n  border: none;\n  outline: none;\n  background: transparent;\n  font-size: 13.5px;\n  font-family: \"Inter\", system-ui, sans-serif;\n  color: var(--msd-ink);\n  padding: 4px 2px;\n}\n\n.msd-input::placeholder {\n  color: var(--msd-ink-faint);\n}\n\n.msd-chevron {\n  flex-shrink: 0;\n  align-self: center;\n  color: var(--msd-ink-faint);\n  transition: transform 0.15s ease, color 0.15s ease;\n  margin-right: 4px;\n}\n\n.msd-chevron-open {\n  transform: rotate(180deg);\n  color: var(--msd-indigo);\n}\n\n/* Dropdown panel */\n.msd-panel {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  right: 0;\n  background: var(--msd-surface);\n  border: 1px solid var(--msd-line);\n  border-radius: var(--msd-radius);\n  box-shadow: var(--msd-shadow);\n  overflow-y: auto;\n  z-index: 30;\n  animation: msd-panel-in 0.12s ease;\n}\n\n@keyframes msd-panel-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.msd-search-row {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--msd-line);\n  color: var(--msd-ink-faint);\n}\n\n.msd-search-icon {\n  flex-shrink: 0;\n}\n\n.msd-search-hint {\n  font-size: 11.5px;\n  font-weight: 500;\n}\n\n.msd-options {\n  list-style: none;\n  margin: 0;\n  padding: 6px;\n}\n\n.msd-option {\n  padding: 9px 12px;\n  font-size: 13.5px;\n  color: var(--msd-ink);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.1s ease, color 0.1s ease;\n}\n\n.msd-option:hover {\n  background: var(--msd-indigo-soft);\n  color: #3936a8;\n}\n\n.msd-empty {\n  padding: 16px 12px;\n  font-size: 13px;\n  color: var(--msd-ink-faint);\n  text-align: center;\n}\n\n/* Scrollbar polish for the options panel */\n.msd-panel::-webkit-scrollbar {\n  width: 6px;\n}\n.msd-panel::-webkit-scrollbar-thumb {\n  background: var(--msd-line-strong);\n  border-radius: 999px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
